// Tags to help categorize, group, and route the issues to the proper Materio responder
export type IssueTags = {
  eng: 'teddy' | 'thomas' | 'all';
  issue: string; // Kebab-case unique ID for this particular issue, e.g. 'board-img-load'
};

// Extra data about the issue intended for detailed technical debugging
export type IssueData = { [key: string]: string | number | boolean };

/**
 * Report a structured issue to our FE bug tracking system
 */
export function reportIssue(
  message: string,
  details: { tags: IssueTags; data: IssueData },
): void {
  // Always log the issue to the console
  console.error(message, details.tags, details.data);

  // If our FE bug tracking system is active in this environment, also send the issue there
  const win: LogrocketEnhancedWindow = window as LogrocketEnhancedWindow;
  if (win.LogRocket && typeof win.LogRocket.captureMessage === 'function') {
    win.LogRocket.captureMessage(message, {
      tags: details.tags,
      extra: details.data,
    });
  }
}

/**
 * Report an (unstructured) error to our FE bug tracking system
 */
export function trackError(error: Error, data: IssueData = {}): void {
  // Always log the error to the console
  console.error(error);

  // If our FE bug tracking system is active in this environment, send the error there
  const win: LogrocketEnhancedWindow = window as LogrocketEnhancedWindow;
  if (win.LogRocket && typeof win.LogRocket.captureException === 'function') {
    win.LogRocket.captureException(error, { extra: data });
  }
}

type LogrocketEnhancedWindow = {
  LogRocket?: {
    captureMessage: any;
    captureException: any;
  };
};
